<template>
  <div class="signup-section">
    <h3 class="signup-section__title">Ready to get started?</h3>
    <p class="signup-section__subtitle">Join thousands of teams worldwide</p>
    <q-btn flat dense class="signup-section__btn" label="Sign up for free" @click="handleSignupClick" no-caps />
    <p class="signup-section__note">No credit card required</p>
  </div>
</template>

<script>
export default {
  name: 'SignupSection',

  methods: {
    handleSignupClick() {
      // Navigate to signup page
      this.$router.push({ name: 'authRegister' });
    }
  }
};
</script>

<style lang="scss" scoped>
.signup-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 24px;
  background-color: var(--secondary-bg-color);
  border-radius: 8px;
  border: 1px solid var(--light-grey-hr);

  @media (max-width: 768px) {
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding: 24px 16px;
  }

  &__title {
    @include mona-sans-font($size: 18px, $bolded: true, $color: var(--main-text-color));
    margin: 0;
    line-height: 1.2;
  }

  &__subtitle {
    @include inter-font($size: 14px, $color: var(--secondary-text-color));
    margin: 0 0 4px 0;
  }

  &__btn {
    width: 100%;
    height: 48px;
    background-color: var(--main-btn-color);
    @include inter-font($size: 16px, $bolded: true, $color: var(--main-text-color));
    border-radius: 8px;
    margin-bottom: 4px;
  }

  &__note {
    @include inter-font($size: 14px, $color: var(--secondary-text-color));
    margin: 0;
    opacity: 0.8;
  }
}
</style>
